import { IClosedEndTargetReturnProfile } from '../../interfaces/investment-vehicle/closed-end-target-return-profile.interface';

export class ClosedEndTargetReturnProfile implements IClosedEndTargetReturnProfile {
  closedEndDataFieldsId: number | undefined = undefined;
  gpTargetReturnsGross: number | undefined = undefined;
  gpTargetReturnsNet: number | undefined = undefined;
  targetAnnualDivident: number | undefined = undefined;
  gpTargetGrossMultiple: number | undefined = undefined;
  gpTargetNetMultiple: number | undefined = undefined;
}
